export default __webpack_public_path__ + "static/media/01AW1SEP66.cffd59af.jpg";